import { Injectable } from '@angular/core';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root',
})
export class CindiService {
  private pontuation: number = 0;
  private finalQuestionsPontuation: number = 0;
  heigth!: number;
  weigth!: number;

  constructor(private messageService: MessageService) {}

  addPontuation(points: number) {
    this.pontuation += points;
  }
}
